export default "__VITE_ASSET__8030c7f3__"